import { render, staticRenderFns } from "./FlipConfirmationModal.vue?vue&type=template&id=327a9834&scoped=true"
import script from "./FlipConfirmationModal.vue?vue&type=script&lang=js"
export * from "./FlipConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./FlipConfirmationModal.vue?vue&type=style&index=0&id=327a9834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a9834",
  null
  
)

export default component.exports